
export type ID = string | number;
export type PRIMITIVE = string | number | boolean | null | undefined;



export interface PageProps {
  query: any;
  params: {
    id?: ID;
    gridId?: number;
    gridLocation?: string;
  };
}


export enum CONFIGLEVEL {
  GLOBAL = "GLOBAL",
  TENANTGROUP = "TENANTGROUP",
  TENANT = "TENANT",
  USER = "USER",
}


export enum MODULE {
  core = "core",
  invoicing = "invoicing",
  ordering = "ordering",
  party = "party",
  product = "product",
  shipment = "shipment",
  accounting = "accounting",
  humanresource = "humanresource",
  sbtool = "sbtool",
  ecommerce = "ecommerce"
}

export enum SECURABLE_TYPE {
  PAGE = "PAGE",
  BULKACTION = "BULKACTION",
  DETAILACTION = "DETAILACTION",
  API = "API"
}


export enum PERMISSION {
  Read = "Read",
  New = "New",
  Update = "Update",
  Delete = "Delete",
  Execute = "Execute",
  Export = "Export",
  Import = "Import",
  PublicGrid = "PublicGrid",
  TenantGrid = "TenantGrid",
  TenantGroupGrid = "TenantGroupGrid",
}

export interface ISECURABLE {
  name: TSECURABLE;
  module: MODULE;
  type?: SECURABLE_TYPE;
  permission?: PERMISSION;
  detailHeader?: string;
}



const _SECURABLE = {
  issuedInvoiceList: {name: 'issuedInvoiceList', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Issued invoices list permission"},
  invoiceDetail: {name: 'invoiceDetail', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Invoice detail permission"},
  invoiceTemplateList: {name: 'invoiceTemplateList', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Invoice template list permission"},
  invoiceTemplateDetail: {name: 'invoiceTemplateDetail', module: MODULE.invoicing, type: SECURABLE_TYPE.PAGE, detailHeader: "Invoice template detail permission"},

  issueInvoice: {name: 'issueInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION, detailHeader: "Issue invoice permission"},
  issueInvoices: {name: 'issueInvoices', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION},
  downloadInvoices: {name: 'downloadInvoices', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION},
  emailInvoices: {name: 'emailInvoices', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION},
  cancelInvoice: {name: 'cancelInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION},
  reopenInvoice: {name: 'reopenInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION},
  sendInvoice: {name: 'sendInvoice', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION},
  invoiceSettlement: {name: 'invoiceSettlement', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION},
  vatRateOverride: {name: 'vatRateOverride', module: MODULE.invoicing, type: SECURABLE_TYPE.DETAILACTION},

  assignProducts: {name: 'assignProducts', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION},
  assignProductsCustomPrice: {name: 'assignProductsCustomPrice', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION},

  vehicleNotification: {name: 'vehicleNotification', module: MODULE.product, type: SECURABLE_TYPE.DETAILACTION},
  vehiclesNotification: {name: 'vehiclesNotification', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION},
  
  brimMessageList: {name: 'brimMessageList', module: MODULE.product, type: SECURABLE_TYPE.PAGE},
  brimMessageAction: {name: 'brimMessageAction', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION},

  customerNotification: {name: 'customerNotification', module: MODULE.party, type: SECURABLE_TYPE.DETAILACTION},
  customerRegistration: {name: 'customerRegistration', module: MODULE.party, type: SECURABLE_TYPE.DETAILACTION},

  setPassword: {name: 'setPassword', module: MODULE.core, type: SECURABLE_TYPE.DETAILACTION},
  impersonate: {name: 'impersonate', module: MODULE.core, type: SECURABLE_TYPE.DETAILACTION},

  partyGridUpdate: {name: 'partyGridUpdate', module: MODULE.party, type: SECURABLE_TYPE.BULKACTION},
  invoiceGridUpdate: {name: 'invoiceGridUpdate', module: MODULE.invoicing, type: SECURABLE_TYPE.BULKACTION},
  productGridUpdate: {name: 'productGridUpdate', module: MODULE.product, type: SECURABLE_TYPE.BULKACTION},
  shipmentGridUpdate: {name: 'shipmentGridUpdate', module: MODULE.shipment, type: SECURABLE_TYPE.BULKACTION},
  shipmentRepackagingGridUpdate: {name: 'shipmentRepackagingGridUpdate', module: MODULE.shipment, type: SECURABLE_TYPE.BULKACTION},
  shipmentVisitDetail: {name: 'shipmentVisitDetail', module: MODULE.shipment, type: SECURABLE_TYPE.PAGE, permission: PERMISSION.New},
  shipmentRepackagingAdvance: {name: 'shipmentRepackagingAdvance', module: MODULE.shipment, type: SECURABLE_TYPE.BULKACTION},

  shipmentRepackagingSetResource: {name: 'shipmentRepackagingSetResource', module: MODULE.shipment, type: SECURABLE_TYPE.DETAILACTION},
  shipmentRepackagingSetNorm: {name: 'shipmentRepackagingSetNorm', module: MODULE.shipment, type: SECURABLE_TYPE.DETAILACTION},


  activityList: {name: 'activityList', module: MODULE.core, type: SECURABLE_TYPE.PAGE, permission: PERMISSION.Delete},


  employeeAttendance: {name: "employeeAttendance", module: MODULE.humanresource, type: SECURABLE_TYPE.DETAILACTION},

  jobList: {name: "jobList", module: MODULE.core, type: SECURABLE_TYPE.PAGE, detailHeader: "Jobs list permissions"},
  jobDetail: {name: "jobDetail", module: MODULE.core, type: SECURABLE_TYPE.PAGE, detailHeader: "Job detail permissions"},

  entityFieldDetail: {name: "entityFieldDetail", module: MODULE.core, type: SECURABLE_TYPE.PAGE},
  documentTemplateDetail: {name: "documentTemplateDetail", module: MODULE.core, type: SECURABLE_TYPE.PAGE},


};

export type TSECURABLE = keyof typeof _SECURABLE;

export const SECURABLE: {[key in TSECURABLE]: ISECURABLE} = _SECURABLE as any;

export interface SecurableComponentProps extends React.Attributes {
  module?: MODULE;
  securableType?: SECURABLE_TYPE;
  securable?: ISECURABLE;
  permission?: PERMISSION;
  detailId?: string;
  style?: any;
}



export class EntityConfig {

  public entityName: string;
  public entityConstructorFunction: any;
  public detailroute: string;

  constructor (entityName, entityConstructorFunction?: any) {
    this.entityName = entityName;
    this.entityConstructorFunction = entityConstructorFunction;
  }

  getFormName(historyObject) {
    return this.entityName + "Form";
  }
}






// WEBPACK FOOTER //
// ./src/core/metamodel/metaConstant.ts